import Tags from '@plone/volto/components/theme/Tags/Tags';

const slots = {
  belowContent: [
    {
      name: 'tags',
      component: Tags,
    },
  ],
};

export default slots;
